import "./index.less";

import React, { useCallback, useEffect, useState } from "react";
import { useLanguage, useTranslate } from "@obsbot/remo-i18n";
import { Button, Checkbox, Form } from "antd";

import { useSafePromise } from "../../../utils/hooks";
import { LoginAgreement, LoginAgreementProps } from "../LoginAgreement";
import { LoginPanelContent } from "../LoginPanelContent";
// import { requestAgreement } from "../LoginAgreement";
import { LoginAccount } from "../LoginAccount";
import { LoginPassword } from "../LoginPassword";
import { LoginButtonProviderType } from "../LoginButton";
import { LoginButtonsProps } from "../LoginButtons";
import { accountValidator, validateEmail } from "./validators";
import { RememberPassword } from "@obsbot/remo-utils";
import { sendVerifyCode } from "@obsbot/remo-server-api";
import { v4 as uuidv4 } from "uuid";
import { validatePhone } from "../../../utils/validators";
export * from "../LoginButtons";
export * from "./validators";

export enum PasswordLoginPageType {
    Login = "login",
    Reset = "reset-password",
}

interface LoginFormValues {
    account: string;
    password: string;
}

export interface LoginWithPasswordProps {
    buttons?: LoginButtonProviderType[];
    privacyURL?: LoginAgreementProps["privacyURL"];
    serviceURL?: LoginAgreementProps["serviceURL"];
    login: (account: string, password: string) => Promise<boolean>;
    onClickButton?: LoginButtonsProps["onClick"];
    toForgotPwd: (account: string) => void;
}

export const LoginWithPassword: React.FC<LoginWithPasswordProps> = ({
    privacyURL,
    serviceURL,
    login,
    toForgotPwd,
    // register,
    // sendVerificationCode,
}) => {
    const t = useTranslate();
    const sp = useSafePromise();
    const lang = useLanguage();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // const [agreed, setAgreed] = useState(false);
    const [clickedLogin, setClickedLogin] = useState(false);
    // const [clickedReset, setClickedReset] = useState(false);
    const [form] = Form.useForm<LoginFormValues>();
    const [isFormValidated, setIsFormValidated] = useState(false);
    const [isAccountValidated, setIsAccountValidated] = useState(
        form.getFieldError("account").length === 0,
    );
    const defaultValues = {
        account: "",
        password: "",
    };
    const [password, setPassword] = useState(defaultValues.password);
    const [validatingAccount, setValidatingAccount] = useState<boolean>(false);
    const [isSavePwd, setIsSavePwd] = useState(RememberPassword.hasStoredPassword());
    // 受控：只显示红色样式，不显示提示文字
    const [passwordHasError, setPasswordHasError] = useState(false);
    console.log("isAccountValidated", isAccountValidated);

    useEffect(() => {
        const cryptoKey = window.isElectron
            ? (window as any).node.os.hostname()
            : navigator.userAgent;
        const password = RememberPassword.getPassword(cryptoKey);
        try {
            if (password) {
                const info = JSON.parse(password);
                form.setFieldsValue({
                    account: info.account,
                    password: isSavePwd ? info.password : "",
                });
                if (isSavePwd) {
                    setPassword(info.password);
                }
                formValidateStatus();
            } else {
                RememberPassword.clearPassword();
            }
        } catch (error) {
            console.log("[WEB] DEBUG 解析存储的密码出错", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     const cryptoKey = window.isElectron
    //         ? (window as any).node.os.hostname()
    //         : navigator.userAgent;
    //     const password = RememberPassword.getPassword(cryptoKey);
    //     try {
    //         if (password) {
    //             const info = JSON.parse(password);
    //             form.setFieldsValue({
    //                 account: form.getFieldValue("account"),
    //                 password: form.getFieldValue("password"),
    //             });
    //             if (isSavePwd) {
    //                 setPassword(info.password);
    //             }
    //             formValidateStatus();
    //         } else {
    //             RememberPassword.clearPassword();
    //         }
    //     } catch (error) {
    //         console.log("[WEB] DEBUG 解析存储的密码出错", error);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isSavePwd, form]);

    const doLogin = useCallback(async () => {
        // TODO: 这里是因为测试submenu是否有效所以注释了, 后续按需启用
        // if (!agreed) {
        //     if (!(await requestAgreement({ t, privacyURL, serviceURL }))) {
        //         return;
        //     }
        //     setAgreed(true);
        // }
        setClickedLogin(true);
        const { account: accountValue, password } = form.getFieldsValue();
        sp(login(accountValue, password))
            .then(res => {
                setClickedLogin(false);
                if (!res) {
                    return;
                }
                const cryptoKey = window.isElectron
                    ? (window as any).node.os.hostname()
                    : navigator.userAgent;
                try {
                    // 如果要保存密码，就将最新的密码保存，如果不保存密码，就只保存账号
                    RememberPassword.savePassword(
                        { account: accountValue, password: isSavePwd ? password : "" },
                        cryptoKey,
                        7,
                    );
                } catch (error) {
                    //
                }
                if (!RememberPassword.hasStoredPassword()) {
                    RememberPassword.savePassword(
                        { account: accountValue, password: isSavePwd ? password : "" },
                        cryptoKey,
                        7,
                    );
                }
            })
            .catch(error => {
                setClickedLogin(false);
                if ((error as any)?.code === "RM.100102") {
                    // 开启红色错误样式，但不展示错误文字
                    setPasswordHasError(true);
                    // 清空默认错误文案，避免出现提示文本
                    form.setFields([{ name: "password", errors: [] }]);
                    return;
                }
                console.error("登录报错", error);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, isSavePwd]);

    const formValidateStatus = useCallback(() => {
        const pwd = form.getFieldValue("password");
        const account = form.getFieldValue("account");
        let validate = false;
        if (account.includes("@")) {
            validate = validateEmail(account);
        } else {
            validate = validatePhone(account);
        }
        const condition = validate && !!account && pwd?.length >= 6 && pwd?.length <= 20;
        setIsFormValidated(condition);
        if (account && condition) {
            setIsAccountValidated(true);
        } else {
            setIsAccountValidated(false);
        }
    }, [form]);

    // useEffect(() => {
    //     formValidateStatus();
    // }, [form, formValidateStatus]);

    const handleForgotPwd = async (): Promise<void> => {
        if (form.getFieldValue("account")) {
            setValidatingAccount(true);
            onGetCode(form.getFieldValue("account"));
        } else {
            form.validateFields(["account"]);
            setValidatingAccount(false);
        }
    };

    const onGetCode = async (account: string): Promise<Boolean> => {
        return sp(
            sendVerifyCode({
                account: account,
                msg_type: "forget_pwd",
                client_type: (window as any).isElectron ? "game_client" : "web",
                mobile_id: uuidv4(),
                lan: lang === "zh-CN" ? "cn" : lang,
            }),
        )
            .then(res => {
                console.log("获取验证码", res);
                if (res.verification_code === null) {
                    setValidatingAccount(false);
                    toForgotPwd(account);
                    return true;
                }
                setValidatingAccount(false);
                return false;
            })
            .catch(() => {
                setValidatingAccount(false);
                return false;
            });
    };

    function renderLoginPage(): React.ReactNode {
        return (
            <div className="login-with-email">
                <div className="login-width-limiter">
                    <Form
                        form={form}
                        initialValues={defaultValues}
                        name="loginWithPassword"
                        onFieldsChange={formValidateStatus}
                        onFinish={doLogin}
                    >
                        <Form.Item
                            name="account"
                            rules={[accountValidator(t)]}
                            validateTrigger={["onBlur"]}
                        >
                            <LoginAccount
                                password={password}
                                placeholder={t("login-page.enter-email-or-phone")}
                                onFocus={() => form.setFields([{ name: "account", errors: [] }])}
                                onHistoryChange={options => {
                                    form.setFieldsValue({
                                        account: options.value,
                                        password: options.key,
                                    });
                                    setPassword(options.key);
                                    formValidateStatus();
                                }}
                            />
                        </Form.Item>
                        {/* 登录不再校验密码规则, 后端校验失败展示错误信息 */}
                        <Form.Item
                            help={passwordHasError ? null : undefined}
                            name="password"
                            style={{ marginBottom: 4 }}
                            // 只变红，不显示文字
                            validateStatus={passwordHasError ? "error" : undefined}
                        >
                            <LoginPassword
                                placeholder={t("login-page.enter-password")}
                                onFocus={() => {
                                    // 聚焦时清除红色状态
                                    setPasswordHasError(false);
                                    form.setFields([{ name: "password", errors: [] }]);
                                }}
                            />
                        </Form.Item>
                        <div className="login-with-pwd-btn-wrapper">
                            <Checkbox checked={isSavePwd} onChange={() => setIsSavePwd(!isSavePwd)}>
                                {t("login-page.login-save-password")}
                            </Checkbox>
                            <Button
                                disabled={validatingAccount}
                                style={{ padding: 0 }}
                                type="text"
                                onClick={handleForgotPwd}
                            >
                                {validatingAccount
                                    ? t("login-page.validate-account")
                                    : t("login-page.forgot")}
                            </Button>
                        </div>
                        <Button
                            className="login-big-button login-with-email-login-btn"
                            disabled={!isFormValidated}
                            htmlType="submit"
                            loading={clickedLogin}
                            type="primary"
                        >
                            {t("login-page.login")}
                        </Button>
                    </Form>
                    <LoginAgreement privacyURL={privacyURL} serviceURL={serviceURL} />
                </div>
            </div>
        );
    }
    return <LoginPanelContent transitionKey={"login"}>{renderLoginPage()}</LoginPanelContent>;
};
